import { PersistService } from 'utils/persist';

// AuthGuard -> AppLayout -> OverviewPage is a serial React.lazy() chain (each is nested inside
// the previous one's rendered output), so React only requests each chunk once its parent has
// loaded and rendered. Firing these imports in parallel lets the browser's module cache
// short-circuit that chain for the most common landing route. Guests never reach it, so they
// shouldn't pay for it: it would compete with the sign-in page's own critical resources.
export function prefetchAuthenticatedRoutes() {
  const { accessToken } = PersistService.getCredentials();

  if (!accessToken) return;

  import('modules/common/guards').catch(() => {});
  import('modules/common/layouts').catch(() => {});
  import('modules/dashboard/pages').catch(() => {});
}
